namespace Matrix.Administration {
    export namespace SupportTicketService {
        export const baseUrl = 'SupportTicket';

        export declare function SendEmail(request: SupportTicketSendEmailRequest, onSuccess?: (response: SupportTicketSendEmailResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            SendEmail = "SupportTicket/SendEmail"
        }

        [
            'SendEmail'
        ].forEach(x => {
            (<any>SupportTicketService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
